import React from 'react';
import { showAllQuery, useSearchQuestion, useSearchResults } from '@context/DataContext';

export const ResultsSummary = () => {
  const { resultsSummary: summary } = useSearchResults();
  const { query: searchQuery } = useSearchQuestion();
  const resultName = summary.totalMatching === 1 ? 'result' : 'results';
  const maybeQuery =
    searchQuery !== showAllQuery && searchQuery.trim() ? (
      <>
        {' '}
        for <strong>{searchQuery.trim()}</strong>
      </>
    ) : null;
  const maybeLastResult =
    summary.totalMatching > 1 ? (
      <>
        {' - '}
        <span id="search-page-end">{summary.currEnd}</span>
      </>
    ) : null;
  const maybeTotalResults =
    summary.totalMatching > 1 ? (
      <>
        {' '}
        of <span id="search-total-matching">{summary.totalMatching}</span>
      </>
    ) : null;
  return summary.totalMatching > 1 ? (
    <div className="base-search-banner__results-summary">
      Displaying <span id="search-page-start">{summary.currStart}</span>
      {maybeLastResult}
      {maybeTotalResults} {resultName}
      {maybeQuery}
    </div>
  ) : (
    <></>
  );
};

export default ResultsSummary;
